import React, { useEffect } from 'react';
import { IpadShowcase } from '../components/landing/IpadShowcase';

// Temporary preview-only route — used to screenshot the iPad showcase before
// mounting it on the live Landing page. Safe to delete after approval.
export const IpadPreview = () => {
  useEffect(() => {
    document.title = 'iPad Showcase Preview · Epicurea Nexus';
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#28282B';
    return () => { document.body.style.backgroundColor = prev; };
  }, []);

  return (
    <div data-landing-page="true" className="min-h-screen text-white" style={{ backgroundColor: '#28282B' }}>
      <IpadShowcase />
    </div>
  );
};

export default IpadPreview;
